import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalStateService } from '../global/global-state.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private  service_type = "general"
  public baseURL = '';

  constructor(private _globalStateService: GlobalStateService, private _http: HttpClient) {
    this.baseURL = this._globalStateService.GetBaseEndpoint('base');
  }

  GetMakes(): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/car-makers?paginate=false`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  GetModels(maker_slug:any=''): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/car-models?paginate=false&make=${maker_slug}`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  GetCountries(): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/countries?paginate=false`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  GetCachedData(type:string): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/data-cached/${type}`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  GetYards(): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/yards?paginate=false`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

  DeleteDataById(id:any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint
    return this._http.delete<any>(url);
  }

  AddData(data:any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}`; // Replace with your API endpoint
    return this._http.post<any>(url,data);
  }

  UpdateData(id:string,data:any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/${id}`; // Replace with your API endpoint

    return this._http.patch<any>(url,data);
  }


  uploadFileByContent(data:any): Observable<any>{

    const url = `${this.baseURL}/${this.service_type}/get-presigned-url`; // Replace with your API endpoint
    return this._http.post<any>(url,data);

  }

  convertKeysToFormdata(obj:any,file:any){

    const formData = new FormData();

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        formData.append(key, obj[key]);
      }
    }

    formData.append("file",file)

    return formData;
  }

  sendFileToS3(url:any,formData:any):Observable<any>{

    return this._http.post<any>(url,formData);

  }

  generatePDF(data: any): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/generate-pdf`; // Replace with your API endpoint
    return this._http.post<any>(url, data);
  }

  generateExcel(data: any): string {
    let params = new URLSearchParams(data).toString();

    const url = `${this.baseURL}/${this.service_type}/generate-excel?${params}`; // Replace with your API endpoint
    // return this._http.get<any>(url);
    return url;
  }

  generateExcelPost(data: any): Observable<any> {

    const url = `${this.baseURL}/${this.service_type}/generate-excel`; // Replace with your API endpoint
    return this._http.post<any>(url,data);
  }

  generateTemplateExcel(body:any): Observable<any> {

    const url = `${this.baseURL}/${this.service_type}/generate-template-excel`; // Replace with your API endpoint
    // return this._http.get<any>(url);
    return this._http.post<any>(url,body);

  }

  DashboardData(): Observable<any> {
    const url = `${this.baseURL}/${this.service_type}/dashboard`; // Replace with your API endpoint
    return this._http.get<any>(url);
  }

}

